import { render, staticRenderFns } from "./UsersReport.vue?vue&type=template&id=70dd0560&scoped=true&"
import script from "./UsersReport.vue?vue&type=script&lang=js&"
export * from "./UsersReport.vue?vue&type=script&lang=js&"
import style0 from "./UsersReport.vue?vue&type=style&index=0&id=70dd0560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd0560",
  null
  
)

export default component.exports